import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import { checkActivationBySlug, hasRole } from '../../utils/utilityFuncs'

/**
 * Guards routes that require a product to be activated (e.g. exolab, virtual-exolab).
 * Reads product slug from the route param and redirects to "/" if the user
 * does not have that product activated (admins bypass).
 *
 * Usage: use paramName "slug" for /experiments/:slug or "product" for /experiments/:product/create
 */
const ActivatedProductRoute = ({
  component,
  allowedRoles,
  paramName = 'slug',
  ...rest
}) => {
  const { activations } = useSelector((state) => state.initial) || {}
  const { roles } = useSelector((state) => state.auth.user) || {}
  const isAdmin = hasRole(['superadmin', 'district-admin'], roles)

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        const productSlug = routeProps.match?.params?.[paramName]
        const hasProductActivated =
          isAdmin || (productSlug && checkActivationBySlug(productSlug, activations))

        if (productSlug && !hasProductActivated) {
          return <Redirect to="/" />
        }

        return (
          <PrivateRoute
            component={component}
            allowedRoles={allowedRoles}
            {...rest}
          />
        )
      }}
    />
  )
}

export default ActivatedProductRoute
